import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import styled from "styled-components";

import ViewFooter from "../views/ViewFooter";

import ViewGerenciarPeriodos from "../views/ViewGerenciarPeriodos";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";


const ContainerComponente = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  @media (min-width: 200px) and (max-width: 399px) {
    padding: 8px;
    gap: 10px;
  }

  @media (min-width: 400px) and (max-width: 799px) {
    flex-wrap: wrap;
    gap: 15px;
  }

  @media (min-width: 800px) {
    justify-content: space-between;
    align-items: flex-start;
    gap: 30px;
  }
`;

const GerenciarPeriodos: React.FC = () => {
   const { isLoading, isValid } = usePermissao("OPE");
    
      if (isLoading) return <p>Verificando permissão...</p>;
      if (!isValid) return null;
    return (
  <ContainerComponente>
    <ViewAppBar />
    <ViewGerenciarPeriodos />
  
    <ViewFooter />
  </ContainerComponente>
)};
export default GerenciarPeriodos;
